export default __webpack_public_path__ + "static/media/0xb2a83eD5Ad69933067dF57FE9273f85fe32FFcFa.f580eef9.svg";